module.exports = __webpack_public_path__ + "img/CRC.c1e92e31.svg";